import { useContext } from 'react';
import { ThemeContext, ThemeContextData } from '../context/theme';

export function useTheme(): ThemeContextData {
  const context = useContext(ThemeContext);

  return context;
}
